export default __webpack_public_path__ + "static/media/004-walnut.c5d4290b.svg";